/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPersonalFinanceWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPersonalFinanceWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Financially Savvy!",
    "Finance Workshop Awaits!",
    "Master Your Money!",
  ],
  title: "Personal Finance Workshop",
  description: "Organize an informative personal finance workshop.",
  longDescription:
    "Gather your friends for a personal finance workshop! Choose a date, decide on topics to cover, and plan activities for the session!",
  emoji: "💰",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Personal Finance Workshop",
          emoji: "💰",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the personal finance workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on topics to cover?",
            description:
              "What topics do we want to explore during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What topics should we consider?",
                emoji: "📊",
                completeAction: {
                  question: "Decide on tools needed?",
                  description:
                    "What tools should we gather for managing finances?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "🧰",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Financially Fit!",
    outroDescription:
      "Your personal finance workshop plans are set! Enjoy the insights!",
  },
};
